export class CreateVehicleModelModel {
  public modelo = ''
  public tipoVeiculoId = 0
  public veiculoMarcaId = 0
}

export class EditVehicleModelModel {
  public id = 0
  public descricao = ''
  public tipoVeiculoId = 0
  public veiculoMarcaId = 0
}

export class DeleteVehicleModelModel {
  public id = 0
  public descricao = ''
}

export class SearchVehicleModelModel {
  public modelo = ''
}

export class CreateVehicleModelResponse {
  public response: any
}
export class EditVehicleModelResponse {
  public response: any
}
export class DeleteVehicleModelResponse {
  public response: any
}
export class PagedVehicleModelResponse {
  public response: any
}
